import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaCog,
  FaClock,
  FaPhoneAlt,
  FaEnvelope,
  FaArrowRight
} from "react-icons/fa";

const socialIcons = [
  <FaFacebookF />,
  <FaInstagram />,
  <FaYoutube />,
  <FaTwitter />
];

const contactInfo = [
  { icon: <FaClock />, text: "Mon – Sun  |  9:00 AM – 8:00 PM" },
  { icon: <FaPhoneAlt />, text: "+91 88797 37412" },
  { icon: <FaEnvelope />, text: "info@srikalikambalautos.in" },
];

const Footer = ({ onOpenModal }) => {
  const year = new Date().getFullYear();
  const quickLinks = ["Home", "About", "Motorcycles", "Contact"];
  const services   = ["Bike Sales", "Test Ride", "Easy Finance", "Service & AMC", "Insurance"];
  const models     = ["Bullet 350", "Hunter 350", "Meteor 350", "Super Meteor 450", "Himalayan"];

  return (
    <>
      <style>{`
        /* ── FONT CHANGE: Oswald (display) + DM Sans (body) ── */
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=DM+Sans:wght@400;500;600&family=Barlow+Condensed:wght@400;600;700;800&display=swap');

        .font-bebas       { font-family: 'Oswald', sans-serif; letter-spacing: 0.02em; }
        .font-barlow      { font-family: 'DM Sans', sans-serif; }
        .font-barlow-cond { font-family: 'Barlow Condensed', sans-serif; }

        .footer-grid-bg {
          background-image:
            linear-gradient(rgba(212,175,55,0.025) 1px, transparent 1px),
            linear-gradient(90deg, rgba(212,175,55,0.025) 1px, transparent 1px);
          background-size: 56px 56px;
        }

        .footer-hex {
          clip-path: polygon(50% 0%,100% 25%,100% 75%,50% 100%,0% 75%,0% 25%);
          animation: hexGlow 3s ease-in-out infinite;
        }
        @keyframes hexGlow {
          0%,100% { box-shadow: 0 0 8px rgba(212,175,55,0.4); }
          50%      { box-shadow: 0 0 22px rgba(212,175,55,0.8), 0 0 40px rgba(212,175,55,0.25); }
        }

        .footer-link {
          position: relative;
          color: #666;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          cursor: pointer;
          transition: color 0.25s, padding-left 0.25s;
          display: flex; align-items: center; gap: 0;
        }
        .footer-link::before {
          content: '→';
          color: #D4AF37;
          opacity: 0;
          font-size: 11px;
          transition: opacity 0.25s, margin-right 0.25s;
          margin-right: 0;
        }
        .footer-link:hover { color: #F5F5F5; padding-left: 4px; }
        .footer-link:hover::before { opacity: 1; margin-right: 6px; }

        .col-header {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 11px; letter-spacing: 4px;
          text-transform: uppercase; color: #D4AF37;
          margin-bottom: 18px;
          display: flex; align-items: center; gap: 8px;
        }
        .col-header::after {
          content: ''; flex: 1; height: 1px;
          background: linear-gradient(to right, rgba(212,175,55,0.4), transparent);
        }

        .social-icon {
          width: 36px; height: 36px;
          border: 1px solid rgba(255,255,255,0.07);
          display: flex; align-items: center; justify-content: center;
          font-size: 14px;
          transition: border-color 0.3s, background 0.3s, transform 0.3s;
          cursor: pointer;
        }
        .social-icon:hover {
          border-color: #D4AF37;
          background: rgba(212,175,55,0.12);
          transform: translateY(-3px);
        }

        .footer-ticker {
          display: flex; gap: 80px; white-space: nowrap;
          animation: fticker 22s linear infinite;
        }
        @keyframes fticker {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }

        .bottom-bar {
          background: linear-gradient(to right, transparent, rgba(212,175,55,0.12), transparent);
        }

        .addr-dot {
          width: 6px; height: 6px; border-radius: 50%;
          background: #D4AF37; flex-shrink: 0;
          margin-top: 6px;
          box-shadow: 0 0 6px rgba(212,175,55,0.6);
        }

        .slash-badge {
          clip-path: polygon(0 0, calc(100% - 8px) 0, 100% 50%, calc(100% - 8px) 100%, 0 100%);
        }

        .footer-watermark {
          font-family: 'Oswald', sans-serif;
          font-size: clamp(80px, 16vw, 200px);
          color: rgba(212,175,55,0.03);
          letter-spacing: -4px;
          pointer-events: none; user-select: none;
          white-space: nowrap; line-height: 1;
        }
      `}</style>

      <footer className="relative w-full bg-[#080808] overflow-hidden">
        <div className="footer-grid-bg absolute inset-0 z-0 pointer-events-none" />
        <div className="footer-watermark absolute bottom-0 left-0 z-0 select-none">SKA</div>
        <div className="absolute right-0 top-8 bottom-24 w-[2px] bg-gradient-to-b from-transparent via-[#D4AF37]/30 to-transparent" />

        {/* TOP TICKER */}
        <div className="border-b border-[#D4AF37]/10 py-3 overflow-hidden relative z-10">
          <div className="footer-ticker">
            {[...Array(2)].flatMap(() =>
              ["Premium Motorcycles", "Authorised Dealer", "Easy Finance", "Test Ride Available", "Expert Service", "Katpadi · Tamil Nadu", "Royal Enfield Partner"].map((t, i) => (
                <div key={`${t}-${i}`} className="flex items-center gap-5 flex-shrink-0">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />
                  <span className="font-barlow-cond text-[11px] tracking-[4px] uppercase text-[#444]">{t}</span>
                </div>
              ))
            )}
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

            {/* COL 1 — BRAND */}
            <div className="lg:col-span-1 flex flex-col gap-5">
              <div className="flex items-center gap-3">
                <div className="footer-hex w-11 h-11 bg-[#D4AF37] flex items-center justify-center text-white text-xl font-bold flex-shrink-0">
                  <FaCog />
                </div>
                <div className="flex flex-col leading-none">
                  <span className="font-bebas text-[20px] tracking-widest text-[#F5F5F5]">Sri Kalikambal</span>
                  <span className="font-barlow-cond text-[9px] tracking-[4px] text-[#D4AF37] uppercase">Autos · Est. 2005</span>
                </div>
              </div>

              {/* Brand paragraph — 14px, brighter */}
              <p className="font-barlow text-[#777] text-[14px] leading-[1.8]">
                Your trusted destination for premium Royal Enfield motorcycles in Katpadi. Ride with confidence.
              </p>

              <div className="flex items-center gap-3">
                <div className="slash-badge bg-[#D4AF37] px-4 py-1.5 font-bebas text-[22px] text-white leading-none">
                  4.9★
                </div>
                <div className="flex flex-col">
                  <span className="font-barlow font-semibold text-[#F5F5F5] text-[13px]">Google Rating</span>
                  <span className="font-barlow-cond text-[#555] text-[10px] tracking-[2px] uppercase">500+ Reviews</span>
                </div>
              </div>

              <div className="flex gap-2 mt-1">
                {socialIcons.map((icon, i) => (
                  <div key={i} className="social-icon text-[#D4AF37] text-[14px]">
                    {icon}
                  </div>
                ))}
              </div>
            </div>

            {/* COL 2 — QUICK LINKS */}
            <div>
              <div className="col-header">Quick Links</div>
              <ul className="flex flex-col gap-3">
                {quickLinks.map((link) => (
                  <li key={link} className="footer-link">{link}</li>
                ))}
              </ul>
            </div>

            {/* COL 3 — SERVICES + MODELS */}
            <div>
              <div className="col-header">Services</div>
              <ul className="flex flex-col gap-3">
                {services.map((s) => (
                  <li key={s} className="footer-link">{s}</li>
                ))}
              </ul>

              <div className="col-header mt-8">Models</div>
              <ul className="flex flex-col gap-3">
                {models.map((m) => (
                  <li key={m} className="footer-link">{m}</li>
                ))}
              </ul>
            </div>

            {/* COL 4 — CONTACT */}
            <div>
              <div className="col-header">Find Us</div>
              <div className="flex flex-col gap-4">
                <div className="flex gap-3">
                  <div className="addr-dot" />
                  {/* Address — 14px, brighter */}
                  <p className="font-barlow text-[#777] text-[14px] leading-[1.8]">
                    No 5, RJ Plaza,<br />
                    Katpadi Main Rd,<br />
                    Viruthampattu,<br />
                    Near Palar Bridge
                  </p>
                </div>

                {contactInfo.map((row) => (
                  <div key={row.text} className="flex items-center gap-3">
                    <span className="text-[#D4AF37] text-[14px]">{row.icon}</span>
                    {/* Contact text — 14px, brighter */}
                    <span className="font-barlow text-[#777] text-[14px]">{row.text}</span>
                  </div>
                ))}

                <button
                onClick={onOpenModal }
                  className="mt-2 self-start flex items-center gap-3 bg-[#D4AF37] hover:bg-[#E5C158] text-white pl-6 pr-4 py-2.5 font-barlow-cond text-[12px] font-bold tracking-[2px] uppercase transition-colors duration-300"
                  style={{ clipPath: "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%)" }}
                >
                  Book Test Ride
                  <div className="w-7 h-7 bg-black/20 flex items-center justify-center text-sm"><FaArrowRight /></div>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="relative z-10 border-t border-[#D4AF37]/10">
          <div className="bottom-bar h-[2px] w-full" />
          <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="font-barlow-cond text-[11px] tracking-[2px] uppercase text-[#444]">
              © {year} Sri Kalikambal Autos. All rights reserved.
            </p>
            <div className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" style={{ boxShadow: "0 0 6px #D4AF37", animation: "pulse 1.5s infinite" }} />
              <span className="font-barlow-cond text-[11px] tracking-[2px] uppercase text-[#444]">
                Authorised Royal Enfield Dealer
              </span>
            </div>
            <p className="font-barlow-cond text-[11px] tracking-[2px] uppercase text-[#2a2a2a]">
              Designed & Developed By Optywize
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;